module.exports = __webpack_public_path__ + "static/media/s_brown.1840d930.mp3";